import { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import PlatoContext from "../context/platos/PlatoContext";
import MenuContext from "../context/menus/MenuContext";
import ListadoMenus from "../components/ListadoMenus";
import FormularioMenu from "../components/FormularioMenu";
import Spinner from "../components/Spinner";

function Menus() {
  // context de la aplicacion
  const { platos, obtenerPlatos } = useContext(PlatoContext);
  const { obtenerMenus, limpiarEstadoMenus, menus } = useContext(MenuContext);

  // estado del componente
  const [show, setShow] = useState(false);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    limpiarEstadoMenus();
    obtenerMenus();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setCargando(true);
    obtenerPlatos();
    setCargando(false);
    // eslint-disable-next-line
  }, []);

  const toggler = () => {
    setShow(!show);
  };

  return cargando ? (
    <Spinner />
  ) : (
    <Container>
      <Titulo>Menús Diarios</Titulo>
      <BtnShow type="button" onClick={toggler} show={show}>
        {show ? (
          <span>
            <FaMinusCircle /> Cerrar
          </span>
        ) : (
          <span>
            <FaPlusCircle /> Nuevo
          </span>
        )}
      </BtnShow>
      <Division>
        {show ? (
          <FormularioMenu platos={platos} toggler={toggler} />
        ) : (
          <ListadoMenus menus={menus} />
        )}
      </Division>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Titulo = styled.h2`
  font-family: "Caveat", cursive;
  font-size: 2rem;
  margin-top: 0;
  margin-bottom: 20px;
`;

const BtnShow = styled.button`
  width: 8rem;
  height: 2rem;
  padding: 0.5rem;
  margin-bottom: 2rem;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  color: #fff;
  background: ${(props) => (props.show ? "#a61f12" : "#034001")};
  outline: none;
  transition: all 0.5s ease;
  &:hover {
    background: ${(props) => (props.show ? "#d92a1a" : "#055902")};
  }
  span {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
`;

const Division = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Menus;
